import {ShiftEntity} from "@ots-frontend/ots-data";
import {LocationHistoryMap} from "../../map/LocationHistoryMap/LocationHistoryMap";
import {useMemo} from "react";
import {LocationHistoryMapFilter} from "../../../model/location-history";
import {useGetShiftLocationHistory} from "../../../hooks/useGetShiftLocationHistory";

export type ShiftMapProps = {
  shift: ShiftEntity
}

export const ShiftMap = (props: ShiftMapProps) => {
  const {shift} = props;

  const {
    history
  } = useGetShiftLocationHistory({
    shift: shift,
  })

  const filter: LocationHistoryMapFilter = useMemo(() => {
    return {
      showSites: false,
      showTransportRoutes: true,
      showGeofenceEvents: true,
      showDriverLocations: true,
      showDriverLocationRoute: false,
      selectedTransportIds: undefined,
    }
  }, [])

  return (
    <LocationHistoryMap
      data={history}
      filter={filter}
    />
  );
};

